import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "HomeView",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/index",
    name: "frame",
    component: () => import("../views/Frame.vue"),
    children: [
      // 关于公司
      {
        path: "about",
        name: "about",
        component: () => import("../views/about/index.vue"),
      },
      // 关于业务
      {
        path: "business",
        name: "business",
        component: () => import("../views/business/index.vue"),
      },
      // 服务项目
      {
        path: "service",
        name: "service",
        component: () => import("../views/service/index.vue"),
      },
      // 新闻中心
      {
        path: "news",
        name: "news",
        component: () => import("../views/news/index.vue"),
      },
      {
        path: "newsDetail",
        name: "newsDetail",
        component: () => import("../views/news/detail.vue"),
      },
      // 招聘
      {
        path: "recruitment",
        name: "recruitment",
        component: () => import("../views/recruitment/index.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location) {
  return (originalPush.call(this, location) as any).catch((err: any) => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

VueRouter.prototype.replace = function replace(location) {
  return (originalReplace.call(this, location) as any).catch((err: any) => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

export default router;
